import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { EsignatureSignedDocuments } from '../../Models/Models/Documents/InstructionDocuments/EsignatureSignedDocuments';

declare var IS_RUNNING_IN_APP_POOL;

export class ESignatureDocumentSignedClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(instructionId: number): Promise<Array<EsignatureSignedDocuments>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/ESignatureDocumentSigned/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.get<Array<EsignatureSignedDocuments>, any>(url, data);
  }
}

